module.exports = __webpack_public_path__ + "img/sec2_button.d80d50d0.jpg";